var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-container',{attrs:{"title":_vm.$t('course section'),"icon":"book","header_buttons":_vm.header_buttons}},[_c('h2',{staticClass:"ui header"},[_c('i',{staticClass:"users icon"}),(_vm.section)?_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.section.name)+" "),_c('small',[_vm._v("| "+_vm._s(_vm.section.setup.schedule))]),(
          _vm.section &&
            _vm.section.crs_assignation_season &&
            _vm.section.crs_assignation_season
        )?_c('div',{staticClass:"sub header"},[_vm._v(" "+_vm._s(_vm.section.crs_assignation_season.name)+" ")]):_vm._e()]):_vm._e()]),_c('weighting',{ref:"weighting"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }